import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TimezoneService } from '@core/services/timezone.service';
import { NotificationListItem, NotificationType } from '@shared/models';
import { merge, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ComponentContext } from '../../../modules/modal/modal.model';

export interface EditAlertAndNotificationModalData {
  notification: NotificationListItem;
}

@Component({
  selector: 'gcc-edit-notification-modal',
  templateUrl: './edit-notification-modal.component.html',
  styleUrls: ['./edit-notification-modal.component.scss'],
  standalone: false
})
export class EditNotificationModalComponent
  implements OnInit, ComponentContext<EditAlertAndNotificationModalData, Date>
{
  @Input() public notification: NotificationListItem;
  @Input() public onClose: () => void;
  @Input() public onAction: (value: Date) => void;

  public notificationType = NotificationType;
  public form: FormGroup;
  public timezone$: Observable<string>;

  get currentDate() {
    return this.timezoneService.shiftToLocal(new Date());
  }

  constructor(
    private fb: FormBuilder,
    private timezoneService: TimezoneService
  ) {}

  public ngOnInit(): void {
    this.initForm();

    this.timezone$ = merge(of(this.notification?.endDate), this.form.get('endDate').valueChanges).pipe(
      map(date => this.timezoneService.getTimezoneOffset(date))
    );
  }

  public handleAction() {
    const convertedEndDate = this.timezoneService.shiftFromLocal(this.form.get('endDate').value);
    this.onAction(convertedEndDate);
  }

  private initForm() {
    const convertedEndDate = this.timezoneService.shiftToLocal(this.notification?.endDate);

    this.form = this.fb.group({
      endDate: [convertedEndDate, Validators.required]
    });
  }
}
